<div class="row" [class.px-3]="quickFilterSpacing" *ngIf="_tableDisplayConfig">

  <div class="col-12">

    <form [formGroup]="columnFilterForm">

      <div class="row" [class.my-3]="rowSpacing" [class.my-2]="quickFilterSpacing">

        <ng-container *ngFor="let column of tableConfig?.columns">

          <div
            class="col-12 py-2"
            [class.col-sm-6]="!compactView"
            [class.col-sm-4]="compactView"
            *ngIf="
              (column.filterable && column.filter_visible && !(globalFilter?.[column.name]) && !quickFilterOnly) ||
              (column.filterable && column.filter_visible && !(globalFilter?.[column.name]) && (quickFilterOnly && column.quick_filter))
          ">

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.STRING  || column.type === TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA">
              <app-form-group
                [formControl]="$any(columnFilterForm.get(column.name))"
                type="text"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
                [class.custom-compact-input]="compactView"
              ></app-form-group>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.BOOL">
              <app-multi-select-with-static-options
                [inline]="inlineInput"
                [small]="smallInput"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="false"
                [name]="column.name"
                [selectOptions]="[
                { value: 'enums.bool.1' | translate,key: '1'},
                { value: 'enums.bool.0' | translate,key: '0'}
                ]"
              ></app-multi-select-with-static-options>
            </ng-container>

            <ng-container
              *ngIf="[TableConfigColumnTypeEnum.MODEL_STATE_ENUM , TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE].includes($any(column.type))">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ModelStateEnum"
                translateKey="modelStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.INT">
              <app-int-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="(column.name) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '')"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
                [small]="smallInput"
                [class.custom-compact-input]="compactView"
              ></app-int-filter>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.DATE">
              <app-date-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="(column.name) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '')"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
              ></app-date-filter>
            </ng-container>


            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.CARBON_IMMUTABLE">
              <app-date-filter
                *ngIf="$any(columnFilterForm.get(column.name))"
                [formControlName]="column.name"
                [label]="(column.name) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '')"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [inline]="inlineInput"
                [showLabel]="! column.quick_filter"
              ></app-date-filter>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_STATE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="PatientStateEnum"
                translateKey="patientStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.EMAIL_TYPE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="EmailTypeEnum"
                translateKey="emailTypeEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_LANGUAGE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="PatientLanguageEnum"
                translateKey="patientLanguageEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_EMAIL">
              <app-multi-select-with-service-id-array
                [searchOnField]="'title'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="emailService"
                [sort]="'title'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_DIAGNOSIS">
              <app-multi-select-with-service-id-array
                [searchOnField]="'title'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="diagnosisService"
                [filters]="{'is_category': 'false'}"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_DIAGNOSIS_CATEGORY">
              <app-multi-select-with-service-id-array
                [searchOnField]="'title'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="diagnosisService"
                [filters]="{'is_category': 'true'}"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_USER">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="userService"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_TEAM_LEADER">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="addableTeamLeadersService"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.ARRAY">
              <code>{{ column.type }} filter not implemented on column {{ column.name }} </code>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_GENDER_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="PatientGenderEnum"
                translateKey="patientGenderEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.INQUIRY_STATE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="InquiryStateEnum"
                translateKey="inquiryStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_PATIENT">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="patientService"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_CATEGORY_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ProcessCategoryEnum"
                translateKey="processCategoryEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_ROLE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ProcessRoleEnum"
                translateKey="processRoleEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_PRIORITY_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ProcessPriorityEnum"
                translateKey="processPriorityEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_COMPLEXITY_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="ProcessComplexityEnum"
                translateKey="processComplexityEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_USER">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="userService"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_DOCTOR">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="addableDoctorService"
                [sort]="'-created_at'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_BACKOFFICE_USER">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="addableBackofficeUserService"
                [sort]="'-created_at'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_PROCESS">
              <app-multi-select-with-service-id-array
                [searchOnField]="'ext_id'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="processService"
                [sort]="'ext_id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.TIME_TRACKING_ENTRY_TYPE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="TimeTrackingEntryTypeEnum"
                translateKey="timeTrackingEntryTypeEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="TimeTrackingAbsenceRequestStateEnum"
                translateKey="timeTrackingAbsenceRequestStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <ng-container
              *ngIf="column.type === TableConfigColumnTypeEnum.FK_TIME_TRACKING_EMPLOYEE">
              <app-multi-select-with-service-id-array
                [searchOnField]="'name'"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [service]="timeTrackingEmployeeService"
                [sort]="'id'"
                size="sm"
                [inline]="inlineInput"
                [name]="column.name"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [small]="smallInput"
              ></app-multi-select-with-service-id-array>
            </ng-container>

            <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.GERMAN_STATE_ENUM">
              <app-multi-select-enum
                [inline]="inlineInput"
                [small]="smallInput"
                [name]="column.name"
                [formControl]="$any(columnFilterForm.get(column.name))"
                [label]="!withoutLabel ? (('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(columnFilterForm.get(column.name)).hasValidator(Validators.required) ? ' *': '') : ''"
                [placeholder]="('tables.' + tableConfig?.id + '.' + column.name) |translate"
                [multi]="true"
                [enum]="GermanStateEnum"
                translateKey="germanStateEnum"
              ></app-multi-select-enum>
            </ng-container>

            <div class="alert alert-warning small"
                 *ngIf="![
                          TableConfigColumnTypeEnum.CARBON_IMMUTABLE,
                          TableConfigColumnTypeEnum.STRING,
                          TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA,
                          TableConfigColumnTypeEnum.INT,
                          TableConfigColumnTypeEnum.MONEY,
                          TableConfigColumnTypeEnum.ARRAY,
                          TableConfigColumnTypeEnum.BOOL,
                          TableConfigColumnTypeEnum.MODEL_STATE_ENUM,
                          TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE,
                          TableConfigColumnTypeEnum.PATIENT_STATE_ENUM,
                          TableConfigColumnTypeEnum.EMAIL_TYPE_ENUM,
                          TableConfigColumnTypeEnum.PATIENT_LANGUAGE_ENUM,
                          TableConfigColumnTypeEnum.FK_EMAIL,
                          TableConfigColumnTypeEnum.FK_DIAGNOSIS,
                          TableConfigColumnTypeEnum.FK_DIAGNOSIS_CATEGORY,
                          TableConfigColumnTypeEnum.PATIENT_GENDER_ENUM,
                          TableConfigColumnTypeEnum.INQUIRY_STATE_ENUM,
                          TableConfigColumnTypeEnum.FK_PATIENT,
                          TableConfigColumnTypeEnum.FK_USER,
                          TableConfigColumnTypeEnum.COMPUTED_BACKOFFICE_USER,
                          TableConfigColumnTypeEnum.COMPUTED_DOCTOR,
                          TableConfigColumnTypeEnum.QM_PROCESS_CATEGORY_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_ROLE_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_PRIORITY_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_COMPLEXITY_ENUM,
                          TableConfigColumnTypeEnum.FK_PROCESS,
                          TableConfigColumnTypeEnum.COMPUTED_TEAM_LEADER,
                          TableConfigColumnTypeEnum.TIME_TRACKING_ENTRY_TYPE_ENUM,
                          TableConfigColumnTypeEnum.TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM,
                          TableConfigColumnTypeEnum.FK_TIME_TRACKING_EMPLOYEE,
                          TableConfigColumnTypeEnum.GERMAN_STATE_ENUM,
                          ].includes($any(column.type))
                      && ['local', 'local-stage'].includes(environment.env_name)">

              (table-filter) Type not implemented: <code>{{ column.type }}</code> (column: {{ column | json }})
            </div>

          </div>

        </ng-container>

      </div>

      <div *ngIf="!quickFilterOnly" class="row">
        <div class="col-12 col-sm-6 py-2">
          <button class="btn btn-primary" (click)="resetFilter()">Reset Filter</button>
        </div>
      </div>

    </form>
  </div>
</div>
